(() => {
  if (window.mhhHeaderLoaded) return;
  window.mhhHeaderLoaded = true;
  const instances = new Map();

  function init(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const { signal } = controller;
    const one = selector => root.querySelector(selector);
    const all = selector => [...root.querySelectorAll(selector)];
    const listen = (target, event, fn, options = {}) => target.addEventListener(event, fn, { ...options, signal });
    const top = one('[data-mhh-top]');
    const header = one('[data-mhh-header]');
    const scrim = one('[data-mhh-scrim]');
    const backdrop = one('.mhh-mega-bg');
    const inline = one('[data-mhh-search-inline]');
    const overlay = one('[data-mhh-search-overlay]');
    const searchButton = one('[data-mhh-search-open]');
    const drawer = one('[data-mhh-drawer]');
    const drawerBg = one('[data-mhh-drawer-bg]');
    const menuButton = one('[data-mhh-menu]');
    const wide = matchMedia('(min-width:1024px)');
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    const messages = all('.mhh-ann-msg');
    let current = null, intent, leaveTimer, settleTimer, restoreTimer, drawerTimer;
    let frame = 0, compact = false, last = scrollY, messageIndex = 0;
    let paused = false, editorBlock = false, modal = null, previousFocus = null, savedLock = null;

    function announce(index) {
      messageIndex = index;
      messages.forEach((message, i) => {
        const active = i === index;
        message.classList.toggle('mhh-is-on', active);
        message.setAttribute('aria-hidden', String(!active));
        message.querySelectorAll('a').forEach(link => { link.tabIndex = active ? 0 : -1; });
      });
    }
    const announcement = one('.mhh-ann');
    if (announcement) {
      listen(announcement, 'mouseenter', () => { paused = true; });
      listen(announcement, 'mouseleave', () => { paused = false; });
    }
    const rotation = setInterval(() => {
      if (!reduced.matches && !paused && !editorBlock && messages.length > 1 && !announcement.contains(document.activeElement)) {
        announce((messageIndex + 1) % messages.length);
      }
    }, 5000);

    function syncScrim() { scrim.hidden = !current && modal !== inline; }
    function fit() {
      if (!current) return;
      const panel = current.querySelector('.mhh-dd');
      backdrop.style.top = `${panel.getBoundingClientRect().top}px`;
      backdrop.style.height = `${panel.offsetHeight}px`;
    }
    function closeMenu(restoreFocus = false) {
      clearTimeout(intent);
      clearTimeout(leaveTimer);
      if (!current) return;
      const button = current.querySelector('.mhh-nav-l');
      current.classList.remove('mhh-open');
      current.querySelector('.mhh-dd').inert = true;
      button.setAttribute('aria-expanded', 'false');
      current = null;
      top.classList.remove('mhh-dd-switch');
      backdrop.classList.remove('mhh-on');
      syncScrim();
      if (restoreFocus) button.focus({ preventScroll: true });
    }
    function showMenu(item) {
      if (!wide.matches || modal) return;
      clearTimeout(intent);
      clearTimeout(leaveTimer);
      if (current === item) return;
      const switching = !!current;
      closeMenu();
      current = item;
      top.classList.remove('mhh-is-hidden');
      top.classList.toggle('mhh-dd-switch', switching);
      item.classList.add('mhh-open');
      item.querySelector('.mhh-dd').inert = false;
      item.querySelector('.mhh-nav-l').setAttribute('aria-expanded', 'true');
      if (!switching) backdrop.style.transition = 'none';
      fit();
      if (!switching) {
        void backdrop.offsetHeight;
        backdrop.style.transition = '';
      }
      backdrop.classList.add('mhh-on');
      syncScrim();
    }
    all('.mhh-has-dd').forEach(item => {
      const button = item.querySelector('.mhh-nav-l');
      listen(item, 'mouseenter', () => {
        clearTimeout(leaveTimer);
        clearTimeout(intent);
        if (current && current !== item) intent = setTimeout(() => showMenu(item), 80);
        else showMenu(item);
      });
      listen(item, 'mouseleave', () => {
        clearTimeout(intent);
        if (!item.contains(document.activeElement)) leaveTimer = setTimeout(() => closeMenu(), 150);
      });
      listen(button, 'click', () => current === item ? closeMenu() : showMenu(item));
      listen(button, 'keydown', event => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          showMenu(item);
          item.querySelector('.mhh-dd a')?.focus();
        }
      });
      listen(item, 'focusout', event => {
        if (!item.contains(event.relatedTarget)) closeMenu();
      });
    });

    function lock(on) {
      const body = document.body;
      if (on && !savedLock) {
        savedLock = { overflow: body.style.overflow, padding: body.style.paddingRight, topPadding: top.style.paddingRight };
        const compensation = innerWidth - document.documentElement.clientWidth;
        if (compensation > 0) {
          body.style.paddingRight = `${parseFloat(getComputedStyle(body).paddingRight) + compensation}px`;
          top.style.paddingRight = `${compensation}px`;
        }
        body.style.overflow = 'hidden';
      } else if (!on && savedLock) {
        body.style.overflow = savedLock.overflow;
        body.style.paddingRight = savedLock.padding;
        top.style.paddingRight = savedLock.topPadding;
        savedLock = null;
      }
    }
    function closeModal(restoreFocus = true) {
      if (!modal) return;
      const wasDrawer = modal === drawer;
      modal = null;
      if (wasDrawer) {
        drawer.classList.remove('mhh-is-open');
        drawer.inert = true;
        drawerBg.hidden = true;
        menuButton.setAttribute('aria-expanded', 'false');
        drawerTimer = setTimeout(() => { drawer.hidden = true; }, reduced.matches ? 0 : 300);
      } else {
        inline.hidden = overlay.hidden = true;
        header.classList.remove('mhh-is-searching');
        searchButton.setAttribute('aria-expanded', 'false');
        all('input[name="q"]').forEach(input => { input.value = ''; });
      }
      lock(false);
      syncScrim();
      if (restoreFocus && previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    }
    function openModal(kind) {
      closeModal(false);
      closeMenu();
      clearTimeout(drawerTimer);
      previousFocus = kind === 'drawer' ? menuButton : searchButton;
      modal = kind === 'drawer' ? drawer : wide.matches ? inline : overlay;
      top.classList.remove('mhh-is-hidden');
      modal.hidden = false;
      modal.inert = false;
      if (modal === drawer) {
        drawerBg.hidden = false;
        void drawer.offsetWidth;
        drawer.classList.add('mhh-is-open');
        menuButton.setAttribute('aria-expanded', 'true');
      } else {
        header.classList.toggle('mhh-is-searching', wide.matches);
        searchButton.setAttribute('aria-expanded', 'true');
      }
      lock(true);
      syncScrim();
      (modal.querySelector('input') || modal).focus({ preventScroll: true });
    }
    listen(searchButton, 'click', () => openModal('search'));
    listen(menuButton, 'click', () => openModal('drawer'));
    all('[data-mhh-search-close], [data-mhh-drawer-close]').forEach(button => listen(button, 'click', () => closeModal()));
    listen(drawerBg, 'click', () => closeModal());
    listen(scrim, 'click', () => { closeMenu(); closeModal(); });
    listen(root, 'click', event => {
      if (event.target.closest('a')) { closeMenu(); closeModal(false); }
    });
    listen(document, 'click', event => { if (!root.contains(event.target)) closeMenu(); });
    listen(document, 'keydown', event => {
      if (event.key === 'Escape') {
        if (current || modal) { event.preventDefault(); closeMenu(true); closeModal(); }
        return;
      }
      if (event.key !== 'Tab' || !modal) return;
      const focusable = [...modal.querySelectorAll('a[href], button, input, summary, [tabindex="0"]')].filter(node => !node.disabled && node.getClientRects().length);
      const first = focusable[0], lastItem = focusable.at(-1);
      if (event.shiftKey && (document.activeElement === first || document.activeElement === modal)) {
        event.preventDefault(); lastItem?.focus();
      } else if (!event.shiftKey && (document.activeElement === lastItem || document.activeElement === modal)) {
        event.preventDefault(); first?.focus();
      }
    });
    listen(document, 'focusin', event => {
      if (modal && !modal.contains(event.target)) (modal.querySelector('input, button') || modal).focus({ preventScroll: true });
    });
    listen(wide, 'change', () => { closeMenu(); closeModal(false); });

    function scrollState() {
      frame = 0;
      if (top.classList.contains('mhh-no-anim')) { settle(); return; }
      const y = scrollY;
      if (!compact && y > 160) compact = true;
      else if (compact && y < 40) compact = false;
      top.classList.toggle('mhh-is-compact', compact);
      if (Math.abs(y - last) < 6) return;
      top.classList.toggle('mhh-is-hidden', y > last && y > 160 && !root.querySelector('.is-mcocod-header-atc-active') && !current && !modal && !root.contains(document.activeElement));
      last = y;
    }
    function settle() {
      top.classList.add('mhh-no-anim');
      if (scrollY > 160) compact = true;
      top.classList.toggle('mhh-is-compact', compact);
      top.classList.remove('mhh-is-hidden');
      last = scrollY;
      clearTimeout(settleTimer);
      settleTimer = setTimeout(() => top.classList.remove('mhh-no-anim'), 250);
    }
    function settleAll() { settle(); clearTimeout(restoreTimer); restoreTimer = setTimeout(settle, 120); }
    listen(window, 'scroll', () => { if (!frame) frame = requestAnimationFrame(scrollState); }, { passive: true });
    listen(window, 'pageshow', settleAll);
    listen(window, 'load', settleAll);
    listen(window, 'resize', fit, { passive: true });
    const resize = new ResizeObserver(fit);
    resize.observe(header);
    all('.mhh-dd').forEach(panel => resize.observe(panel));
    // The placeholder keeps the expanded height through compact/hidden states.
    function measurePlaceholder() {
      const announcementHeight = announcement ? (wide.matches ? 48 : 40) : 0;
      one('.mhh-top-ph').style.height = `${announcementHeight + (wide.matches ? 80 : 60) + 1}px`;
    }
    listen(wide, 'change', measurePlaceholder);
    measurePlaceholder();
    settle();

    function selectBlock(id) {
      editorBlock = true;
      closeModal(false);
      closeMenu();
      const element = all('[data-mhh-block]').find(node => node.dataset.mhhBlock === id);
      const mobileElement = all('[data-mhh-mobile-block]').find(node => node.dataset.mhhMobileBlock === id);
      const message = messages.indexOf(element);
      if (message >= 0) { announce(message); top.classList.remove('mhh-is-compact', 'mhh-is-hidden'); return; }
      if (wide.matches) {
        const parent = element?.closest('.mhh-has-dd');
        if (parent) showMenu(parent);
        else if (element) top.classList.remove('mhh-is-hidden');
        else if (all('[data-mhh-product-label]').some(node => node.dataset.mhhProductLabel === id)) {
          const products = all('.mhh-has-dd').find(node => node.querySelector('.mhh-pl'));
          if (products) showMenu(products);
        }
      } else if (mobileElement || all('[data-mhh-product-label]').some(node => node.dataset.mhhProductLabel === id)) {
        openModal('drawer');
        const target = mobileElement || drawer.querySelector('[data-mhh-product-label]');
        const details = target?.closest('details');
        if (details) details.open = true;
        target?.scrollIntoView({ block: 'nearest' });
      }
    }
    instances.set(root, {
      selectBlock,
      deselect() { editorBlock = false; closeMenu(); closeModal(false); settle(); },
      select() { top.classList.remove('mhh-is-hidden'); },
      destroy() {
        closeModal(false);
        controller.abort();
        resize.disconnect();
        clearInterval(rotation);
        [intent, leaveTimer, settleTimer, restoreTimer, drawerTimer].forEach(clearTimeout);
        cancelAnimationFrame(frame);
        instances.delete(root);
      }
    });
  }

  const initAll = () => document.querySelectorAll('[data-mhh-root]').forEach(init);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, api] of instances) if (event.target.contains(root)) api.destroy();
  });
  document.addEventListener('shopify:section:select', event => {
    for (const [root, api] of instances) if (event.target.contains(root)) api.select();
  });
  document.addEventListener('shopify:block:select', event => {
    for (const [root, api] of instances) if (root.dataset.sectionId === event.detail.sectionId) api.selectBlock(event.detail.blockId);
  });
  document.addEventListener('shopify:block:deselect', event => {
    for (const [root, api] of instances) if (root.dataset.sectionId === event.detail.sectionId) api.deselect();
  });
  initAll();
})();
